module.exports = __webpack_public_path__ + "img/logo.aefe1515.png";